module.exports = __webpack_public_path__ + "static/img/img-abstract-left.f85940b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-abstract-left.png
// module id = l3Qw
// module chunks = 36